"use client";

import { useQuery } from "@tanstack/react-query";

import { useAccount } from "#/store/wallet/account/account";

import { fetchPointsHistory } from "../kyan.service";
import { FetchPointsHistoryResponse, FetchPointsRequest } from "../kyan.types";
import { defaultApiResponseHandler } from "../kyan.utils";

export const usePointsHistory = (options?: FetchPointsRequest) => {
  const { account } = useAccount();

  const params = account ? { address: account, ...options } : null;

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["fetchPointsHistory", params],
    queryFn: () =>
      defaultApiResponseHandler<FetchPointsRequest, FetchPointsHistoryResponse>(
        {
          serviceName: "Fetch Points History",
          payload: params!,
          service: fetchPointsHistory,
        },
      ),
    enabled: Boolean(params),
  });

  return { data: data?.data, isLoading, refetch };
};
